import { BaseError } from './BaseError';

export class DataProviderResourceNotFoundError extends BaseError {
  constructor(resource: string) {
    super(`Data provider resource "${resource}" is not found.`);
  }
}
